<template>
  <main class="page-push-record page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button
          @click="$_batchPush()"
          class="btn__add"
          :disabled="!isSelected.length"
          >批量推送</el-button
        >
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="定制系统类型:">
          <el-select
            style="width: 110px"
            v-model="filter.serviceType"
            filterable
            placeholder="定制系统类型"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              style="width: 110px"
              v-for="item in customServiceTypes"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="定制系统:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.sysName"
              :fetch-suggestions="$_searchCCompanies"
              :trigger-on-focus="false"
              value-key="sysName"
              @select="$_selectCCompany"
              style="width: 110px"
              class="input-box"
            ></el-autocomplete>
            <div
              v-show="!searchCCompaniesData.length && filter.sysName"
              @click="$_clearSearchCCompanyData('supplier')"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该定制系统，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="运营商名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.platformName"
              :fetch-suggestions="$_handleSearchPlatform"
              :trigger-on-focus="false"
              value-key="platformName"
              @select="$_handleSelectPlatform"
            ></el-autocomplete>
            <div
              v-show="!searchPlatformData.length && filter.platformName"
              @click="$_clearSearchPlatformData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该运营商，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="品牌名称:">
          <div class="autocomplete-box">
            <el-autocomplete
              v-model="filter.brandName"
              :fetch-suggestions="$_handleSearchBrand"
              :trigger-on-focus="false"
              value-key="brandName"
              @select="$_handleSelectBrand"
            ></el-autocomplete>
            <div
              v-show="!searchBrandData.length && filter.brandName"
              @click="$_clearSearchBrandData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该品牌，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="门店名称:">
          <div class="autocomplete-box" style="width: 110px;">
            <el-autocomplete
              v-model="filter.storeName"
              :fetch-suggestions="$_handleSearchStores"
              :trigger-on-focus="false"
              value-key="storeName"
              @select="$_handleSelectStore"
            ></el-autocomplete>
            <div
              v-show="!searchStoresData.length && filter.storeName"
              @click="$_clearsearchStoresData"
              class="autocomplete-empty el-select-dropdown"
            >
              查无该门店，请重新输入
            </div>
          </div>
        </el-form-item>

        <el-form-item label="平台单号:">
          <el-input
            v-model="filter.extOrderId"
            style="width: 110px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="推送状态:">
          <el-select v-model="filter.pushStatus" style="width: 110px;">
            <el-option
              v-for="item in pushStatusOptions"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="异常信息:">
          <el-input v-model="filter.errorInfo" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item label="推送类型:">
          <el-select v-model="filter.pushType " style="width: 110px;">
            <el-option
              v-for="item in pushTypeList"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间:">
          <el-date-picker
            v-model="filter.createTime"
            type="datetimerange"
            range-separator=" - "
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="最后推送时间:">
          <el-date-picker
            v-model="filter.pushTime"
            type="datetimerange"
            range-separator=" - "
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :selectable="selectable" width="55">
        </el-table-column>
        <el-table-column label="操作" width="200" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_goDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="
                scope.row.pushStatus === 'failure' ||
                  scope.row.pushStatus === 'success'
              "
              class="edit__btn"
              @click="$_singlePush(scope.row.id)"
              >重推</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
        ></el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getTableData"
      ></cd-pagination>
    </div>

    <modify :visible.sync="modify.visible" :id="modify.id"></modify>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import Modify from "./modal-modify";
import autocompleteCustomCompanys from "@/mixins/autocompleteCustomCompanys";

const today = Utils.formatDate(new Date(), "yyyy-MM-dd")

const columns = [
  { key: "pushNo", label: "推送编号", width: 200 },
  { key: "pushStatusDesc", label: "推送状态", width: 120 },
  { key: "errorInfo", label: "异常信息", width: 160 },
  { key: "pushTypeDesc", label: "推送类型", width: 120 },
  { key: "platformName", label: "运营商", width: 120 },
  { key: "brandName", label: "品牌", width: 120 },
  { key: "storeName", label: "门店名称", width: 120 },
  { key: "vendorName", label: "定制系统", width: 120 },
  { key: "sysTypeName", label: "定制系统类型", width: 120 },
  { key: "extOrderId", label: "平台单号", width: 160 },
  { key: "originData", label: "原始数据", width: 160 },
  { key: "responseBody", label: "响应内容", width: 160 },
  { key: "operator", label: "操作人", width: 160 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "updateTime", label: "最后推送时间", width: 160 },
];

const initFilter = {
  serviceType: "", // 定制系统类型
  sysType: "", // 与mixins冲突，定制系统类型
  sysName: "",
  vendor: "", // 定制系统
  platformKey: "", // 运营商key
  brandId: null, // 品牌id
  storeId: "", // 门店id
  extOrderId: "", // 平台单号
  pushStatus: null, // 推送状态
  errorInfo: "", // 异常信息
  pushType: "", // 推送类型
  createTime: [`${today} 00:00:00`, `${today} 23:59:59`], // 创建时间
  pushTime: [], // 推送时间
}

export default {
  name: "custom-push-record",
  mixins: [resize, autocompleteCustomCompanys],
  components: {
    Modify
  },
  data() {
    return {
      isSelected: [],
      dialog: {
        visible: false,
        data: {},
      },
      isLoading: false,
      pushStatusOptions: [],
      filter: JSON.parse(JSON.stringify(initFilter)),
      customServiceTypes: [],
      searchPlatformData: [],
      searchBrandData: [],
      searchStoresData: [],
      tableHeight: null,
      dataList: [],
      pushTypeList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        total: 0,
      },
      modify: {
        visible: false,
        id: 0
      },
    };
  },
  async created() {
    this.$_getTableData();
    this.$_getStatusList();
    this.$_getPushTypeList();
    // 获取定制系统类型
    let result = await this.$service.post("getCustomServiceTypes");
    if (result.$.checkResult(result, true)) {
      this.customServiceTypes = [...result.data];
    } else {
      return false;
    }
  },
  mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
  },
  methods: {
    // 判断是否禁用多选框
    selectable(row) {
      return row.pushStatus === 'success' || row.pushStatus === 'failure'
    },
    handleSelectionChange(val) {
      this.isSelected = val
    },
    $_getPushTypeList() {
      this.$service.post("getPushTypeEnums").then(result => {
        if (result.$.checkResult(result, true)) {
          this.pushTypeList = result.data
        }
      });
    },
    // 批量推送
    $_batchPush() {
      const self = this
      const content = '是否确认重新推送所选中的异常记录？重新推送记录将被更新'
      const params = this.isSelected.map(item => item.id)
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service.post("customPushBatchPush", {ids: params}).then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getTableData();
                  }
                });
              }
            });
        }
      })
    },
    // 单个推送
    $_singlePush(id) {
      const self = this
      const content = '是否确认重新推送该异常记录？重新推送记录将被更新'
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service.post("customPushSinglePush", {id}).then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getTableData();
                  }
                });
              }
            });
        }
      })
    },
    // 详情
    $_goDetail(row) {
      this.modify.visible = true
      this.modify.id = row.id
    },
    async $_getTableData() {
      this.isLoading = true;
      try {
        const { createTime, pushTime, serviceType, sysName, sysType, vendor, ...filter } = this.filter;
        const filterData = {
          ...filter,
          beginCreateTime: createTime && createTime[0],
          endCreateTime: createTime && createTime[1],
          beginPushTime: pushTime && pushTime[0],
          endPushTime: pushTime && pushTime[1]
        };
        const { total, ...paginationParams } = this.pagination;
        const params = Object.assign({}, filterData, paginationParams, {sysType: serviceType,vendor: sysType});
        await this.$service.post("getCustomPushList", params).then((result) => {
          if (result.$.checkResult(result, true)) {
            this.dataList = result.data.rows;
            this.pagination.total = result.data.total;
          }
        });
      } finally {
        this.isLoading = false;
      }
    },
    $_getStatusList() {
      this.$service.post("getPushStatusEnums").then((result) => {
        if (result.$.checkResult(result, true)) {
          this.pushStatusOptions = result.data;
        }
      });
    },
    // 下拉联想运营商
    $_handleSearchPlatform(platformName, cb) {
      let postData = {
        platformName: platformName,
        pageNow: 1,
        pageSize: 9999,
      };
      this.$service.post("getPlatformList", postData).then((result) => {
        //运营商分页查询
        if (result.$.checkResult(result, true)) {
          this.searchPlatformData = result.data.rows.concat([]);

          cb(result.data.rows);
        }
      });
    },
    // 选择运营商
    $_handleSelectPlatform(item) {
      this.filter.platformName = item.platformName;
      this.filter.platformKey = item.platformKey;
    },
    $_clearSearchPlatformData() {
      this.filter.platformName = "";
      this.filter.platformKey = "";
    },
    // 下拉联想品牌
    $_handleSearchBrand(brandName, cb) {
      let postData = {
        brandName: brandName,
        pageNow: 1,
        pageSize: 9999,
      };
      if (this.filter.platformKey !== "") {
        Object.assign(postData, { platformKey: this.filter.platformKey });
      }
      this.$service.post("getBrands", postData).then((result) => {
        // 品牌分页查询
        if (result.$.checkResult(result, true)) {
          this.searchBrandData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择品牌
    $_handleSelectBrand(item) {
      this.filter.brandName = item.brandName;
      this.filter.brandId = item.brandId;
    },
    $_clearSearchBrandData() {
      this.filter.brandName = "";
      this.filter.brandId = 0;
    },
    // 下拉联想门店
    $_handleSearchStores(storeName, cb) {
      let postData = {
        storeName,
        pageNow: 1,
        pageSize: 9999,
      };
      if (this.filter.brandId !== 0) {
        Object.assign(postData, { brandId: this.filter.brandId });
      }
      this.$service.post("getStores", postData).then((result) => {
        //门店分页查询
        if (result.$.checkResult(result, true)) {
          this.searchStoresData = result.data.rows.concat([]);
          cb(result.data.rows);
        }
      });
    },
    // 选择门店
    $_handleSelectStore(item) {
      this.filter.storeName = item.storeName;
      this.filter.storeId = item.storeId;
    },
    $_clearsearchStoresData() {
      this.filter.storeName = "";
      this.filter.storeId = "";
    },

    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getTableData();
    },
    // 重置
    $_reset() {
      this.filter = JSON.parse(JSON.stringify(initFilter))
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getTableData();
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getTableData();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
  }

  .filter-form {
    .autocomplete-box {
      display: inline-block;
      position: relative;
      width: 110px;
      .autocomplete-empty {
        padding: 10px;
        margin: 0;
        color: #535353;
        width: 100%;
      }
    }
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
</style>
